import styled from "@emotion/styled";

export const Container = styled.div`
  background-color: var(--alias-color-background-normal-alternative);
  height: calc(100vh - 64px);
  display: flex;
  flex-direction: column;
`;

export const WorkspaceCreateContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 480px;
  box-sizing: border-box;
  padding: 80px 40px 120px 40px;
  text-align: center;
  margin: 0 auto;
`;

export const ImageContainer = styled.img`
  width: 80px;
  height: 80px;
  border-radius: 16px;
  border: 1px solid var(--alias-color-line-normal);
  box-sizing: border-box;
  margin: 0 auto;

  cursor: pointer;
`;
